import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GameErrorContent } from '@/modules/game/GameError/components/GameErrorContent';
import { ScGameError } from './styles';
import type { GameErrorT } from './types';

interface IGameErrorProps {
  error: GameErrorT;
  isAutoHeight?: boolean;
}

export const GameError: FC<IGameErrorProps> = ({ error, isAutoHeight }) => {
  const {
    i18n: { language },
  } = useTranslation('common');

  return (
    <ScGameError className={language.toLowerCase()} isAutoHeight={isAutoHeight}>
      <GameErrorContent error={error} />
    </ScGameError>
  );
};
